import type { SVGProps } from 'react'
const SvgSyMoney = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M3 10c0-1.886 0-2.828.586-3.414S5.114 6 7 6h10c1.886 0 2.828 0 3.414.586S21 8.114 21 10v4c0 1.886 0 2.828-.586 3.414S18.886 18 17 18H7c-1.886 0-2.828 0-3.414-.586S3 15.886 3 14z"
		/>
		<circle cx={12} cy={12} r={2} />
		<rect width={3} height={1} x={5} y={8} rx={0.5} />
		<rect width={3} height={1} x={16} y={15} rx={0.5} />
	</svg>
)
export default SvgSyMoney
